export function isUppercase(text) {
    return /^[^a-z]+$/.test(text);
}
//# sourceMappingURL=isUppercase.js.map